import '../../sass/portals/main.scss';
import $api from '@api/api';
import { Fragment } from 'vue-fragment';

// Components
import SecondaryNav from '@app/Shared/Layouts/SecondaryNav';
import SideNav from '@components/Layouts/SideNav';
import SystemMessages from '@components/Layouts/SystemMessages';
import SystemMessage from '@components/Layouts/SystemMessages/SystemMessage';
import TopNav from '@components/Layouts/TopNav';
import UnsavedChanges from '@components/Layouts/UnsavedChanges';
import Bandwango from '@js/portals/bandwango';

// Services
import IronClad from '@services/IronClad/api';
import axios from 'axios';
import countdown from 'countdown';
import Fuse from 'fuse.js/dist/fuse.js';
import Echo from 'laravel-echo';
import cloneDeep from 'lodash/cloneDeep';
import debounce from 'lodash/debounce';
import groupBy from 'lodash/groupBy';
import isEmpty from 'lodash/isEmpty';
import merge from 'lodash/merge';
import mergeWith from 'lodash/mergeWith';

import isArray from 'lodash/isArray';
import isObject from 'lodash/isObject';
import isEqual from 'lodash/isEqual';

import moment from 'moment-timezone';
import Pusher from 'pusher-js';
import { Device } from 'twilio-client';
import { v4 as uuidV4 } from 'uuid';
import VPhoneNumber from 'v-phone-number';
import { ValidationObserver } from 'vee-validate';
import Vue from 'vue';
// TODO: Convert this away from jQuery
// import Bandwango from '@js/bandwango';

import VueBootstrapDatetimePicker from 'vue-bootstrap-datetimepicker';
import Multiselect from 'vue-multiselect';
import VueTelInputVuetify from 'vue-tel-input-vuetify';
import DateRangePicker from 'vue2-daterange-picker';
import * as VueGoogleMaps from 'vue2-google-maps';
import Draggable from 'vuedraggable';
import { TiptapVuetifyPlugin } from 'tiptap-vuetify';

import { copyToClipboard } from '../../../app/Components/Shared/helpers';

import {
	splitIntoWords,
	toCamelCase,
	toKebabCase,
	toPascalCase,
	toSnakeCase
} from '../../../app/Components/Shared/stringConversion';

// Store for communicating between apps
import store from './store';

// import ApproveVenue from '../../../app/Components/Admin/Venues/Views/components/ApproveVenue';
import VuetifyConfig from './vuetifyConfig';

// Import directives
import autoGrowDirective from './directives/autoGrow';
import closeOnSelectDirective from './directives/closeOnSelect';
import colorDirective from './directives/color';
import colorFlipDirective from './directives/colorFlip';
import revealBtnLabelDirective from './directives/revealBtnLabel';
import twoDecimalsDirective from './directives/twoDecimals';
import toggleOpenDirective from './directives/toggleOpen';
import scrollAnchorDirective from './directives/scrollAnchor';

// Add ajax header to axios
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

// for accessing $vuetify in *.php files
// add vuetify: window.Vuetify as part of new Vue({}) if needed
window.Vuetify = VuetifyConfig;
window.VueTelInputVuetify = VueTelInputVuetify;
window.TiptapVuetifyPlugin = TiptapVuetifyPlugin;
window.VueGoogleMaps = VueGoogleMaps;

// make the store available
window.Vuex = store;

Vue.component('v-phone-number', VPhoneNumber);
Vue.component('date-picker', VueBootstrapDatetimePicker); // Work to get rid of this
Vue.component('multiselect', Multiselect); // Work to get rid of this
window.VueMultiselect = Multiselect; // Work to get rid of this
Vue.component('draggable', Draggable);
Vue.component('date-range-picker', DateRangePicker); // Work to get rid of this
Vue.component('validation-observer', ValidationObserver);

// Layout Components
Vue.component('SecondaryNav', SecondaryNav);
Vue.component('SideNav', SideNav);
Vue.component('SystemMessage', SystemMessage);
Vue.component('SystemMessages', SystemMessages);
Vue.component('TopNav', TopNav);
Vue.component('UnsavedChanges', UnsavedChanges);

// Vue Components
Vue.component('Fragment', Fragment);

// Lazy loaded components
// Vue.component('ApproveVenue', ApproveVenue);

// assign to vue prototype for things used in template (not good practice)
// remove this eventually
Vue.prototype.axios = axios;
Vue.prototype.moment = moment;
Vue.prototype.uuidV4 = uuidV4;
Vue.prototype.Bandwango = Bandwango;
Vue.prototype.Bandwango = Bandwango; // Work to get rid of this
Vue.prototype.countdown = countdown;

Vue.filter('truncate', Bandwango.truncateFilter);
Vue.filter('nl2br', Bandwango.nl2brFilter);
Vue.filter('phone', Bandwango.phoneFilter);
Vue.directive('phone', Bandwango.phoneDirective);
Vue.filter('money', Bandwango.moneyFilter);
Vue.filter('pretty', Bandwango.prettyFilter);
Vue.filter('twoDecimals', Bandwango.twoDecimalsFilter);
Vue.directive('money', Bandwango.moneyDirective);

Vue.directive('autoGrow', autoGrowDirective);
Vue.directive('closeOnSelect', closeOnSelectDirective);
Vue.directive('color', colorDirective);
Vue.directive('colorFlip', colorFlipDirective);
Vue.directive('revealBtnLabel', revealBtnLabelDirective);
Vue.directive('twoDecimals', twoDecimalsDirective);
Vue.directive('toggleOpen', toggleOpenDirective);
Vue.directive('scrollAnchor', scrollAnchorDirective);

window.axios = axios;
window.bwApi = $api;
window.cloneDeep = cloneDeep;
window.countdown = countdown;
window.debounce = debounce;
window.groupBy = groupBy;
window.isEmpty = isEmpty;
window.merge = merge;
window.mergeWith = mergeWith;

window.copyToClipboard = copyToClipboard;

window.splitIntoWords = splitIntoWords;
window.toCamelCase = toCamelCase;
window.toKebabCase = toKebabCase;
window.toPascalCase = toPascalCase;
window.toSnakeCase = toSnakeCase;

window.isArray = isArray;
window.isObject = isObject;
window.isEqual = isEqual;

window.moment = moment;
window.uuidV4 = uuidV4;

window.Bandwango = Bandwango;
window.Fuse = Fuse;
window.IronClad = IronClad;
window.Pusher = Pusher;
window.TwilioDevice = Device;
window.Vue = Vue;
window.EventBus = new Vue();

// Set an object to track if events have been registered
window.EventBusEventsRegistered = {};

window.asdf = process.env.MIX_PUSHER_KEY || 'no existy';

window.Echo = new Echo({
	broadcaster: 'pusher',
	key: process.env.MIX_PUSHER_KEY,
	cluster: process.env.MIX_PUSHER_CLUSTER,
	encrypted: true
});
